import styled, { css } from 'styled-components';

import { COLOURS, FONT_WEIGHT, getBodyFont } from '@belong/themes';

export type GroupingProps = {
  groupsWithPrev?: boolean;
  groupsWithNext?: boolean;
};

export const MessageAuthor = styled.div``;
export const MessageBubble = styled.div``;
export const MessageTime = styled.div``;
export const MessageWrapper = styled.div<{ isIncoming?: boolean } & GroupingProps>`
  display: flex;
  flex-direction: column;
  align-items: ${p => (p.isIncoming ? `flex-start;` : `flex-end;`)};
  margin-bottom: 16px;

  ${MessageAuthor} {
    font-weight: ${FONT_WEIGHT.SEMI_BOLD};
    margin-bottom: 8px;
  }

  ${MessageBubble} {
    position: relative;
    max-width: 90%;
    min-width: 40px; // in case arrow hangs over
    padding: 10px 12px;
    margin-bottom: 30px;

    border-radius: 8px;
    color: ${p => (p.isIncoming ? COLOURS.BLACK : COLOURS.DARK_BLUE)};
    background: ${p => (p.isIncoming ? COLOURS.GREY_100 : COLOURS.LIGHT_BLUE)};
    word-break: break-word;

    a {
      color: ${COLOURS.DARK_BLUE};
    }

    // arrow
    &:after {
      position: absolute;
      ${p => (p.isIncoming ? 'left: 11px;' : 'right: 11px;')}
      bottom: -22px;
      display: block;
      content: '';
      width: 0;
      height: 0;
      border-bottom: 22px solid transparent;
      ${p =>
        p.isIncoming
          ? `border-left: 22px solid ${COLOURS.GREY_100};`
          : `border-right: 22px solid ${COLOURS.LIGHT_BLUE};`}
    }
  }

  ${MessageTime} {
    ${getBodyFont('xs', 'small')}
    color: ${COLOURS.GREY_500};
  }

  // Grouping
  ${p =>
    p.groupsWithNext &&
    css`
      margin-bottom: 4px;

      ${MessageBubble} {
        margin-bottom: 0;

        &:after {
          display: none;
        }

        ${p.isIncoming ? `border-bottom-left-radius: 0;` : `border-bottom-right-radius: 0;`}
      }

      ${MessageTime} {
        display: none;
      }
    `}

  ${p =>
    p.groupsWithPrev &&
    css`
      ${MessageAuthor} {
        display: none;
      }

      ${MessageBubble} {
        ${p.isIncoming ? `border-top-left-radius: 0;` : `border-top-right-radius: 0;`}
      }
    `}
`;
